<app-kontable
        #table
        *ngIf="!dialogApplications"
        id="dt_users"
        title="Company Admin"
        [columns]="[
            { field: 'id', title: 'common.id', filterType: numberFilter },
            'login', 'name', 'surname', 'email',
            { field: 'role_desc', bodyTemplate: isUsersTemplate, filterTemplate: isUsersFilter, filterType: customFilter, title: 'common.role' },
            { field: 'flg_ext', title: 'userForm.externalUser', bodyTemplate: externalUserTemplate, filterType: customFilter, filterTemplate: externalUserFilter }
        ]"
        [titles]="['userForm.login', 'userForm.name', 'userForm.surname', 'userForm.email']"
        [paginationType]="paginationType"
        [service]="srvUsers"
        [showRecoverButton]="false"
        [showDetailsButton]="false"
        [showAddButton]="true"
        [showGlobalFilter]="false"
        [showInfoButton]="false"
        [additionalRowCommands]="customRow"
        [(fireNewDataAvailable)]="newDataAvailable"
        (onAdd)="showAddOrEditDialog($event)"
        (onEdit)="showAddOrEditDialog($event)"
        (onRemove)="delete($event)">

    <ng-template #isUsersTemplate data-testid="isUsersTemplate" let-row>
        <span>{{row.role_desc}}</span>
    </ng-template>

    <ng-template #externalUserTemplate data-testid="externalUserTemplate" let-row>
      <span *ngIf="row.flg_ext === '0'">{{ 'userForm.internalUser' | translate }}</span>
      <span *ngIf="row.flg_ext === '1'">{{ 'userForm.externalUser' | translate }}</span>
    </ng-template>

    <ng-template #isUsersFilter data-testid="isUsersFilter" let-col>
        <p-dropdown [options]="comboOptions" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
    </ng-template>

    <ng-template #externalUserFilter data-testid="externalUserFilter" let-col>
      <p-dropdown [options]="externalUserOptions" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
    </ng-template>

    <ng-template #customRow data-testid="customRow" let-row>
        <p-button label="" pTooltip="{{ 'users.reset_password' | translate }}" icon="fa fa-key" styleClass="ui-button-info" (onClick)="openPswResetDialog(row)"></p-button>
        <p-button label="" pTooltip="{{ 'common.applications' | translate }}" icon="fa fa-laptop" styleClass="ui-button-info" (onClick)="userApplication(row)"></p-button>
        <p-button label="" pTooltip="{{ 'common.storesAndSalesNetworks' | translate }}" icon="fa fa-building" styleClass="ui-button-info" (onClick)="userStoresAndSalesNetworks(row)"></p-button>
    </ng-template>
</app-kontable>

<p-dialog
        id="user-dialog"
        *ngIf="showDialog"
        [(visible)]="showDialog"
        [modal]="true"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()"
        [header]="dialogTitle">
    <app-user-form
            (userAdded)="userAdded($event)"
            (userUpdated)="userUpdated($event)"
            *ngIf="this.srvUsers.userEditing"
            [dialogBoxUser]="this.srvUsers.userEditing"
    ></app-user-form>
</p-dialog>

<p-dialog
        *ngIf="showPswDialog"
        [(visible)]="showPswDialog"
        [modal]="true"
        header="{{ 'customers.auth_reset' | translate }}"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="showPswDialog=false">
        <app-user-psw-reset-form (pswResetted)="resetPwdAction($event)"></app-user-psw-reset-form>
</p-dialog>

<app-user-applications
        *ngIf="dialogApplications"
        [selectedApplications]="selectedApplications"
        (onBackPressed)="dialogApplications = false"
        [activeUser]="userSelected"
        [showRolesButton]="true"
        [fromUser]="true"
        [companyId]="companyId"
></app-user-applications>



// WEBPACK FOOTER //
// ./src/app/views/administration/company-admin/company-admin.component.html